var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReportIssue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    rx: 4,
    fill: "#FFA726"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_498_2463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 54.7708C13.2737 54.2137 13.524 53.6406 13.829 53.1035C20.7033 40.8873 27.5801 28.6738 34.4596 16.4629C34.882 15.7054 35.406 15.1123 36.3092 15.0161C36.6603 14.9678 37.0176 15.012 37.3473 15.1445C37.6771 15.277 37.9685 15.4935 38.194 15.7736C38.3431 15.969 38.474 16.1783 38.585 16.3988C45.6496 28.9303 52.7142 41.4671 59.7787 54.0093C59.9658 54.3223 60.074 54.6782 60.0935 55.0448C60.113 55.4113 60.0431 55.7771 59.8903 56.1091C59.7374 56.4411 59.5064 56.7289 59.218 56.9466C58.9295 57.1643 58.5928 57.3049 58.2381 57.3559C57.9791 57.393 57.7175 57.4077 57.4561 57.4H15.702C14.1379 57.4 13.5514 56.9992 13 55.5243V54.7708ZM54.1284 52.9031L36.5321 21.6813C30.6432 32.138 24.8013 42.4905 18.9358 52.9031H54.1284Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.147 37.2325L37.9358 44.2985C37.9123 45.0239 37.6934 45.2484 36.9856 45.2564C36.6806 45.2564 36.3717 45.2564 36.0667 45.2564C35.4489 45.2564 35.2103 45.0119 35.1869 44.3746C35.1243 42.523 35.0696 40.6673 35.0109 38.8156C34.9223 35.9753 34.8337 33.1337 34.745 30.2907C34.7216 29.4891 34.9484 29.2246 35.7695 29.2246H37.3766C38.1587 29.2246 38.4011 29.4771 38.3737 30.2667C38.3007 32.5886 38.2252 34.9105 38.147 37.2325Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3425 48.5263C38.3425 48.9271 38.3425 49.3279 38.3425 49.7487C38.3425 50.2858 38.0961 50.5303 37.5839 50.5503C36.8957 50.5503 36.2036 50.5503 35.5154 50.5503C35.4191 50.5614 35.3216 50.5504 35.23 50.5181C35.1383 50.4859 35.0549 50.4331 34.9856 50.3636C34.9164 50.2942 34.8631 50.2098 34.8296 50.1166C34.7961 50.0234 34.7832 49.9238 34.792 49.8249C34.792 48.9632 34.792 48.0975 34.792 47.2358C34.7846 47.1363 34.7985 47.0364 34.833 46.9431C34.8674 46.8498 34.9214 46.7654 34.9912 46.6958C35.0609 46.6262 35.1447 46.5732 35.2366 46.5404C35.3285 46.5077 35.4264 46.4961 35.5232 46.5063C36.2114 46.4823 36.9035 46.4823 37.5917 46.5063C38.0961 46.5063 38.3268 46.7829 38.3425 47.3079C38.3542 47.7087 38.3425 48.1175 38.3425 48.5263Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_498_2463"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.1111,
    height: 42.4,
    fill: "white",
    transform: "translate(13 15)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIssue);
export default __webpack_public_path__ + "static/media/reportIssue.1b552f8901c19f199849cc2e133aca34.svg";
export { ForwardRef as ReactComponent };